const getATag = (href, text, customClass) => {
    return `<a class="odf-link-legal odf-link-sm ${customClass}" href="${href}" target="_blank">${text}</a>`;
};

const buildDisclaimerLink = (disclaimerKey, PrivacyKey, TermsKey, PrivacyLink, TermsLink) => {
    const privacyPolicy = getATag(PrivacyLink, PrivacyKey, 'privacy_link');
    const termsConditions = getATag(TermsLink, TermsKey, 'conditions_link');
    return Odigeo.Utils.replaceCmsKeyArgs(disclaimerKey, privacyPolicy, termsConditions);
};

const getEventType = (isUserRegistered, page) => {
    if (isUserRegistered) {
        return page ? 'sign-in' : 'signin';
    }
    return 'register';
};

const processTemplateData = ({keys, options}) => ({
    keys: Odigeo._.extend(keys, {
        signIn: {
            headerTitle: keys.signInHeaderTitle,
            title: keys.signInTitle,
            subTitle: keys.signInSubTitle,
            holderLabel: keys.signInHolderLabel,
            holderNameLabel: keys.signInHolderNames,
            holderLastNamesLabel: keys.signInHolderLastNames,
            holderNamePlaceholder: keys.signInNamePlaceholder,
            holderLastNamePlaceholder: keys.signInLastNamePlaceholder,
            holderEmailPlaceholder: keys.signInEmailPlaceholder,
            holderEmailError: keys.signInEmailError,
            holderNameError: keys.signInNameError,
            holderLastNameError: keys.signInLastNameError,
            holderDisclaimer: keys.signInHolderDisclaimer,
            emailLabel: keys.signInEmailLabel,
            btn: keys.signInBtn,
            upgradeDisclaimer: buildDisclaimerLink(keys.signInUpgradeDisclaimer,
                keys.signInPrivacyPolicyText, keys.signInTermsConditionText,
                keys.signInPrivacyPolicy, keys.signInTermsAndConditions),
        },
        signUp: {
            headerTitle: keys.signUpHeaderTitle,
            title: keys.signUpTitle,
            subTitle: keys.signUpSubTitle,
            holderLabel: keys.signUpHolderLabel,
            holderNameLabel: keys.signUpHolderNames,
            holderLastNamesLabel: keys.signUpHolderLastNames,
            holderNamePlaceholder: keys.signUpNamePlaceholder,
            holderLastNamePlaceholder: keys.signUpLastNamePlaceholder,
            holderEmailPlaceholder: keys.signUpEmailPlaceholder,
            holderEmailError: keys.signUpEmailError,
            holderNameError: keys.signUpNameError,
            holderLastNameError: keys.signUpLastNameError,
            holderDisclaimer: keys.signUpHolderDisclaimer,
            emailLabel: keys.signUpEmailLabel,
            pwdLabel: keys.signUpPwdLabel,
            pwdPlaceholder: keys.signUpPwdPlaceholder,
            pwdError: keys.signUpPwdError,
            pwdEmpty: keys.signUpPwdEmpty,
            btn: keys.signUpBtn,
            upgradeDisclaimer: buildDisclaimerLink(keys.signUpUpgradeDisclaimer,
                keys.signUpPrivacyPolicyText, keys.signUpTermsConditionText,
                keys.signUpPrivacyPolicy, keys.signUpTermsAndConditions),
        },
        primeBenefitsTitle: {
            perkOne: keys.perkOneTitle,
            perkTwo: keys.perkTwoTitle,
            perkThree: keys.perkThreeTitle,
            perkFour: keys.perkFourTitle,
        },
        primeBenefitsSubtitle: {
            perkOne: keys.perkOneSubtitle,
            perkTwo: keys.perkTwoSubtitle,
            perkThree: keys.perkThreeSubtitle,
            perkFour: keys.perkFourSubtitle,
        },
        primeSavingsLeft: {
            one: keys.savingsTableLeftPerkOne,
            two: keys.savingsTableLeftPerkTwo,
            three: keys.savingsTableLeftPerkThree,
            four: keys.savingsTableLeftPerkFour,
            five: keys.savingsTableLeftPerkFive,
        },
        primeSavingsRight: {
            one: keys.savingsTableRightPerkOne,
            two: keys.savingsTableRightPerkTwo,
            three: keys.savingsTableRightPerkThree,
            four: keys.savingsTableRightPerkFour,
            five: keys.savingsTableRightPerkFive,
        },
        primeHowTitle: {
            howTitle: keys.primeHowTitle,
        },
        primeHowSteps: {
            primeHowStep1: keys.primeHowStep1,
            primeHowStep2: keys.primeHowStep2,
            primeHowStep3: keys.primeHowStep3,
        },
        primeStartTrial: {
            primeStartTrial: keys.primeStartTrial,
        },
    }),
    options,
});

module.exports = {
    processTemplateData,
    getEventType,
};
